export default "__VITE_ASSET__DLax6A8Q__"